import Api from '@/api/Api'

export default {
  usePromo (params) {
    return Api().post('PromoCode/use_promo', params)
  }
}



// WEBPACK FOOTER //
// ./src/api/PromoCodeAPI.js